import * as React from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import {NvdbFeature} from "../domain";
import FeaturesState from "../domain/FeaturesState";
import * as selectors from "../selectors";
import {connect} from "react-redux";
import {importNvdbFeatureById, importNvdbFeatureByIdAsType, importNvdbFeatureByIdAsTypeT, importNvdbFeatureByIdT} from "../../../actions/actions";
import {showImportNvdbRoadObjectModal, ShowImportNvdbRoadObjectModal} from "../reducers/actions";
import {RoadObjectTypeOption} from "../selectors";

interface StateProps {
    selectedNvdbRoadObject: NvdbFeature;
    compatibleTypes: RoadObjectTypeOption[];
}

interface DispatchProps {
    doShowImportNvdbRoadObjectModal: ShowImportNvdbRoadObjectModal,
    doImportExistingFeature: importNvdbFeatureByIdT,
    doImportNvdbFeatureAsType: importNvdbFeatureByIdAsTypeT,
}

type Props = StateProps & DispatchProps;

interface State {
    selectedImportTypeId: number;
}

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        selectedNvdbRoadObject: selectors.selectedNvdbRoadObject(state),
        compatibleTypes: selectors.availableRoadObjectTypesForNvdbImport(state),
    }
};

const mapDispatchToProps: DispatchProps = ({
    doShowImportNvdbRoadObjectModal: showImportNvdbRoadObjectModal,
    doImportExistingFeature: importNvdbFeatureById,
    doImportNvdbFeatureAsType: importNvdbFeatureByIdAsType,
});

class ImportRoadObjectModal extends React.Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            selectedImportTypeId: -1,
        }
    }


    private closeModal() {
        this.props.doShowImportNvdbRoadObjectModal(null);
    }

    render() {

        let {selectedNvdbRoadObject, compatibleTypes} = this.props;
        if (!selectedNvdbRoadObject) return null;

        const croppedName = selectedNvdbRoadObject.name.replace(selectedNvdbRoadObject.id, '');
        let sideposisjon = selectedNvdbRoadObject?.stedfestinger[0]?.sideposisjon ?? "Ukjent";

        return (
            <Modal show={true} onHide={() => this.closeModal()} className={"import-roadobject-modal"}>
                <ModalHeader>
                    <ModalTitle>Importer vegobjekt fra NVDB</ModalTitle>
                </ModalHeader>
                <form>
                    <ModalBody>
                        <div className="nvdbfeature">

                            <div className="nvdbfeature-info">
                                <h2 style={{fontWeight: "bold"}}>
                                    <span className='color-mid-gray'>{selectedNvdbRoadObject.typeId} </span>
                                    <span>{croppedName}<br/></span>
                                </h2>


                                <table>
                                    <tbody>
                                    <tr>
                                        <td>Id</td>
                                        <td>{selectedNvdbRoadObject.id}</td>
                                    </tr>
                                    {selectedNvdbRoadObject.attributes
                                        .filter(attr => {
                                            // filter non value attributes
                                            return attr.name.indexOf("Geometri") === -1
                                                && !attr.name.startsWith("Assosiert")
                                                && !attr.name.startsWith("Liste av");
                                        })
                                        .map((attr, i) => {
                                            return <tr key={i}>
                                                <td key={i}>{attr.name}</td>
                                                <td>{attr.value}</td>
                                            </tr>;
                                        })}
                                    <tr>
                                        <td>Sideposisjon</td>
                                        <td>{sideposisjon}</td>
                                    </tr>
                                    <tr>
                                        <td>Startdato</td>
                                        <td>{selectedNvdbRoadObject.startDato}</td>
                                    </tr>
                                    <tr>
                                        <td>Sluttdato</td>
                                        <td>{selectedNvdbRoadObject.sluttDato}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="nvdbfeature-actions">
                                <h3>Importer for endring </h3>


                                <Button onClick={() => {
                                    this.props.doImportExistingFeature(selectedNvdbRoadObject.typeId, selectedNvdbRoadObject.id, 'UPDATE');
                                    this.closeModal();
                                }}>Importer for oppdatering</Button>

                                <Button onClick={() => {
                                    this.props.doImportExistingFeature(selectedNvdbRoadObject.typeId, selectedNvdbRoadObject.id, 'CORRECT');
                                    this.closeModal();
                                }}>Importer for korrigering</Button>

                                <Button onClick={() => {
                                    this.props.doImportExistingFeature(selectedNvdbRoadObject.typeId, selectedNvdbRoadObject.id, 'CLOSE');
                                    this.closeModal();
                                }}>Importer for lukking</Button>
                                <br /><br /><br/>

                                {selectedNvdbRoadObject.missingAttributeTypes.length > 0 &&
                                    <div className={"infobox"} >
                                        Dette objektet inneholder sensitive egenkaper du ikke har rettigheter til å importere:
                                        <ul style={{"margin": "10px 0"}}>
                                            {selectedNvdbRoadObject.missingAttributeTypes.map(attributeType => {
                                                return <li>{attributeType.name}</li>;
                                            })}
                                        </ul>

                                        Du kan importere vegobjektet, men disse egenskapene vil bli utelatt. Dersom du sender inn endringer på objektet vil allikevel de sensitive dataene ivaretas.
                                    </div>
                                }

                                <h3>Importer geometri som ny type</h3>
                                <select className={"typeselect"} style={{width: "100%", marginBottom: "4px"}} onChange={(e) => this.handleImportTypeChange(e)}>
                                    <option key="default" value={-1}>Velg type for import</option>
                                    {compatibleTypes.map(type => {
                                        return <option key={type.id} value={type.id}>{type.name}</option>
                                    })}
                                </select>

                                <Button disabled={this.state.selectedImportTypeId == -1} onClick={() => {
                                    this.handleImportAsNewType();
                                    this.closeModal();}}
                                        >Importer geometri som ny type
                                </Button>

                            </div>

                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button bsStyle="warning" onClick={() => this.closeModal()}>Avbryt</Button>
                    </ModalFooter>
                </form>
            </Modal>
        );


    }

    handleImportTypeChange(e: React.ChangeEvent<HTMLSelectElement>) {
        let selectedImportTypeId = parseInt(e.target.value);
        this.setState({selectedImportTypeId});
    }

    handleImportAsNewType(){
        let nvdbObject = this.props.selectedNvdbRoadObject;
        this.props.doImportNvdbFeatureAsType(nvdbObject.typeId, nvdbObject.id, this.state.selectedImportTypeId)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(ImportRoadObjectModal);